/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 353:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),

/***/ 172:
/***/ ((module) => {

function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 993:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var regeneratorDefine = __webpack_require__(546);
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 869:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var regeneratorAsyncGen = __webpack_require__(887);
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var regenerator = __webpack_require__(993);
var regeneratorAsyncIterator = __webpack_require__(791);
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var OverloadYield = __webpack_require__(172);
var regeneratorDefine = __webpack_require__(546);
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 546:
/***/ ((module) => {

function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 373:
/***/ ((module) => {

function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var OverloadYield = __webpack_require__(172);
var regenerator = __webpack_require__(993);
var regeneratorAsync = __webpack_require__(869);
var regeneratorAsyncGen = __webpack_require__(887);
var regeneratorAsyncIterator = __webpack_require__(791);
var regeneratorKeys = __webpack_require__(373);
var regeneratorValues = __webpack_require__(579);
function _regeneratorRuntime() {
  "use strict";

  var r = regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(738)["default"]);
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 738:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(633)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";

;// ./src/js/utils/dom.ts
var disableScrollClass = 'disable-body-scroll';
var html = document.documentElement;
var scrollPosition = 0;
function disableBgScrollOnIphones() {
  scrollPosition = window.scrollY; // Save the current scroll position

  // Lock the body scroll by setting position fixed and top
  document.body.style.position = 'fixed';
  document.body.style.top = "-".concat(scrollPosition, "px");
  document.body.style.width = '100%'; // Prevent horizontal scrollbar
}
function enableBgScrollOnIphones() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollPosition); // Restore the scroll position

  scrollPosition = 0; // Reset scroll position
}

// Named locks allow multiple independent consumers (e.g. stacked modals) to
// hold a scroll lock simultaneously. Scroll is only re-enabled when every lock
// has been released.
//
// Legacy callers that pass no argument (or a non-string value like
// `document.body` in header.js) share a single '__anonymous__' key, preserving
// the original idempotent behavior where repeated disable/enable calls are safe.
var activeLocks = new Set();
function disableBodyScroll(lockId) {
  var id = typeof lockId === 'string' ? lockId : '__anonymous__';
  activeLocks.add(id);
  if (html.classList.contains(disableScrollClass)) return;
  var scrollBarWidth = "".concat(window.innerWidth - document.documentElement.clientWidth, "px");
  html.style.paddingRight = scrollBarWidth;
  html.style.setProperty('--scroll-bar-width', scrollBarWidth);
  html.classList.add(disableScrollClass);
}
function enableBodyScroll(lockId) {
  var id = typeof lockId === 'string' ? lockId : '__anonymous__';
  activeLocks["delete"](id);
  if (activeLocks.size > 0) return;
  if (!html.classList.contains(disableScrollClass)) return;
  html.classList.remove(disableScrollClass);
  html.style.setProperty('--scroll-bar-width', '');
  html.style.paddingRight = '';
}
;// ./src/js/bundles/snippets/filters-drawer.js

var FiltersDrawer = function FiltersDrawer() {
  var collectionContainer = document.querySelector('.js-collection-container');
  var filtersContainer = collectionContainer.querySelector('.js-filters-container');
  var openButton = collectionContainer.querySelector('.js-open-filters-button');
  var closeButton = collectionContainer.querySelector('.js-close-filters-button');
  var overlay = collectionContainer.querySelector('.js-filters-overlay');
  var openDrawer = function openDrawer() {
    filtersContainer.classList.add('translate-x-0');
    filtersContainer.classList.remove('translate-x-full');
    overlay.classList.remove('hidden');
    openButton.setAttribute('aria-expanded', 'true');
    disableBodyScroll();
  };
  var closeDrawer = function closeDrawer() {
    filtersContainer.classList.remove('translate-x-0');
    filtersContainer.classList.add('translate-x-full');
    overlay.classList.add('hidden');
    openButton.setAttribute('aria-expanded', 'false');
    enableBodyScroll();
  };
  if (filtersContainer && openButton && closeButton && overlay) {
    openButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
  } else {
    console.error("filter drawer's elements not found");
  }
  return {
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };
};
/* harmony default export */ const filters_drawer = (FiltersDrawer);
;// ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function asyncToGenerator_asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(756);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// ./src/js/lib/analytics/publishWithRetry.ts
var MAX_RETRIES = 10;
var RETRY_DELAY_MS = 50;

/**
 * Publish a custom event to the analytics pixel via `Shopify.analytics.publish`,
 * retrying while the Shopify analytics surface loads. Fire-and-forget — never
 * throws. `caller` prefixes the error log if `publish` throws.
 */
function publishWithRetry(caller, eventName, payload) {
  var attempts = 0;
  var _publish = function publish() {
    var _window$Shopify;
    if ((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.analytics) !== null && _window$Shopify !== void 0 && _window$Shopify.publish) {
      try {
        // Keep the call on its receiver — Shopify's publish may read `this`.
        window.Shopify.analytics.publish(eventName, payload);
      } catch (error) {
        console.error("".concat(caller, ": Shopify.analytics.publish threw"), error);
      }
    } else if (++attempts < MAX_RETRIES) {
      setTimeout(_publish, RETRY_DELAY_MS);
    }
  };
  _publish();
}
;// ./src/js/lib/analytics/publishAtcContext.ts

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/** Wire shape consumed by `nuts-analytics-pixel` (`AtcContext` in `index.ts`). */

/**
 * Publish `nuts:product_added_context` so the analytics pixel can pair
 * attribution (including `page_section`) with the next `product_added_to_cart`.
 * Fire-and-forget — never throws.
 */
function publishAtcContext(payload) {
  var _payload$ts;
  var normalized = _objectSpread(_objectSpread({}, payload), {}, {
    variant_id: String(payload.variant_id),
    ts: (_payload$ts = payload.ts) !== null && _payload$ts !== void 0 ? _payload$ts : Date.now()
  });
  publishWithRetry('publishAtcContext', 'nuts:product_added_context', {
    payload: normalized
  });
}

/**
 * Build context from a CTA element's `data-*` attributes. Normalizes the
 * theme's mixed kebab-case / snake_case dataset keys to the wire field names
 * the pixel expects.
 *
 * Accepts `null | undefined` so callers can pass `selectedVariantOption`
 * directly even when it may be null. An absent element is treated as empty
 * dataset — the publish still fires with at least the `variant_id`.
 */
function publishAtcContext_publishAtcContextFromElement(element, variantId) {
  var _element$dataset, _dataset$list_source, _dataset$list_title, _dataset$page_section, _ref, _dataset$product_hand, _dataset$reporting_ca, _dataset$variant_labe;
  var dataset = (_element$dataset = element === null || element === void 0 ? void 0 : element.dataset) !== null && _element$dataset !== void 0 ? _element$dataset : {};
  publishAtcContext({
    variant_id: String(variantId),
    list_source: (_dataset$list_source = dataset.list_source) !== null && _dataset$list_source !== void 0 ? _dataset$list_source : dataset.listSource,
    list_title: (_dataset$list_title = dataset.list_title) !== null && _dataset$list_title !== void 0 ? _dataset$list_title : dataset.listTitle,
    page_section: (_dataset$page_section = dataset.page_section) !== null && _dataset$page_section !== void 0 ? _dataset$page_section : dataset.pageSection,
    position: dataset.position,
    product_handle: (_ref = (_dataset$product_hand = dataset.product_handle) !== null && _dataset$product_hand !== void 0 ? _dataset$product_hand : dataset.productHandle) !== null && _ref !== void 0 ? _ref : dataset.handle,
    reporting_category: (_dataset$reporting_ca = dataset.reporting_category) !== null && _dataset$reporting_ca !== void 0 ? _dataset$reporting_ca : dataset.reportingCategory,
    variant_label: (_dataset$variant_labe = dataset.variant_label) !== null && _dataset$variant_labe !== void 0 ? _dataset$variant_labe : dataset.variantLabel
  });
}
;// ./src/js/bundles/snippets/shipping-meter.js
/**
 * Shipping Meter - handles popover toggle and progress bar updates
 */

// Initialize shipping info popover functionality
var initShippingInfoPopover = function initShippingInfoPopover(container) {
  if (!container) return;
  var trigger = container.querySelector('[data-shipping-info-trigger]');
  var popover = container.querySelector('[data-shipping-info-popover]');
  if (!trigger || !popover) return;
  var closeBtn = popover.querySelector('[data-shipping-info-close]');
  var hide = function hide() {
    popover.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  };
  var _closePopover = function closePopover(evt) {
    if (popover.contains(evt.target) || trigger.contains(evt.target)) return;
    hide();
    document.removeEventListener('click', _closePopover);
    document.removeEventListener('keydown', _handleKeydown);
  };
  var _handleKeydown = function handleKeydown(evt) {
    if (evt.key === 'Escape') {
      hide();
      trigger.focus();
      document.removeEventListener('click', _closePopover);
      document.removeEventListener('keydown', _handleKeydown);
    }
  };
  trigger.addEventListener('click', function (evt) {
    evt.stopPropagation();
    var isHidden = popover.hidden;
    if (isHidden) {
      popover.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        return document.addEventListener('click', _closePopover);
      }, 0);
      document.addEventListener('keydown', _handleKeydown);
    } else {
      _closePopover(evt);
    }
  });
  if (closeBtn) {
    closeBtn.addEventListener('click', function (evt) {
      evt.stopPropagation();
      hide();
      document.removeEventListener('click', _closePopover);
      document.removeEventListener('keydown', _handleKeydown);
      trigger.focus();
    });
  }
};

// Update shipping meter progress based on cart total
var shipping_meter_updateShippingMeter = function updateShippingMeter(cartTotalCents, threshHold) {
  var meters = document.querySelectorAll('[data-shipping-meter]');
  if (!meters.length) return;
  meters.forEach(function (meter) {
    var thresholdCents = threshHold ? threshHold * 100 : parseInt(meter.dataset.thresholdCents, 10) || 0;
    if (thresholdCents <= 0) return;
    var successHtml = meter.dataset.successHtml || 'YAY! You qualify for FREE shipping!';
    var remaining = Math.max(thresholdCents - cartTotalCents, 0);
    var progress = Math.floor(Math.min(cartTotalCents / thresholdCents * 100, 100));

    // Update progress bar
    var bar = meter.querySelector('[data-shipping-meter-bar]');
    if (bar) {
      bar.style.width = "".concat(progress, "%");
    }

    // Update screen reader text
    var srText = meter.querySelector('[data-shipping-meter-sr]');
    if (srText) {
      srText.textContent = "Shipping meter at ".concat(progress, " percent");
    }

    // Update message
    var messageEl = meter.querySelector('[data-shipping-meter-message]');
    if (messageEl) {
      if (remaining > 0) {
        var remainingFormatted = formatMoney(remaining);
        messageEl.innerHTML = "Add <strong class=\"font-semibold\">".concat(remainingFormatted, " more</strong> for FREE shipping!");
      } else {
        messageEl.innerHTML = successHtml;
      }
    }
  });
};

// Format cents to money string
var formatMoney = function formatMoney(cents) {
  var dollars = (cents / 100).toFixed(2);
  return "$".concat(dollars);
};

// Initialize all shipping meters on the page
var initShippingMeter = function initShippingMeter() {
  var meters = document.querySelectorAll('[data-shipping-meter]');
  meters.forEach(function (meter) {
    initShippingInfoPopover(meter);
  });
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(353);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// ./src/js/utils/delivery-estimate.js



var ZIP_STORAGE_KEY = 'pdp_delivery_estimate_zipcode';
var US_ZIP_REGEX = /^\d{5}(-?\d{4})?$/;
var CA_POSTAL_REGEX = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
function sanitizePostalCode(value) {
  if (!value) return null;
  return String(value).replace(/[<>"'=]/g, '');
}
function getStoredZip() {
  try {
    var zipcode = localStorage.getItem(ZIP_STORAGE_KEY);
    return zipcode ? sanitizePostalCode(zipcode) : null;
  } catch (_unused) {
    return null;
  }
}
function setStoredZip(zip) {
  try {
    var safeZip = sanitizePostalCode(zip);
    localStorage.setItem(ZIP_STORAGE_KEY, safeZip);
  } catch (_unused2) {
    // ignore
  }
}
function clearStoredZip() {
  try {
    localStorage.removeItem(ZIP_STORAGE_KEY);
  } catch (_unused3) {
    // ignore
  }
}
function isValidPostalCode(value) {
  if (!value) return false;
  return US_ZIP_REGEX.test(value) || CA_POSTAL_REGEX.test(value);
}
function isCanadaPostalCode(value) {
  return CA_POSTAL_REGEX.test(value);
}

// One lookup per page: variant switches reuse it instead of re-hiding the ZIP
// form for another round-trip. The timeout caps how long its row sits blank.
var ipZipPromise = null;
function fetchZipFromIpApi() {
  if (!ipZipPromise) {
    ipZipPromise = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _AbortSignal$timeout, _AbortSignal, res, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch('https://ipapi.co/json/', {
              // Optional call: browsers without AbortSignal.timeout fetch with no cap.
              signal: (_AbortSignal$timeout = (_AbortSignal = AbortSignal).timeout) === null || _AbortSignal$timeout === void 0 ? void 0 : _AbortSignal$timeout.call(_AbortSignal, 3000)
            });
          case 3:
            res = _context.sent;
            if (res.ok) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", null);
          case 6:
            _context.next = 8;
            return res.json();
          case 8:
            data = _context.sent;
            return _context.abrupt("return", (data === null || data === void 0 ? void 0 : data.postal) || null);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }))();
  }
  return ipZipPromise;
}
function buildShippingPayload(zip, variantData) {
  return {
    shipments: [{
      address: {
        country: 'US',
        residential: true,
        postalCode: zip
      },
      key: 'Address 1',
      lines: [{
        sku: variantData.sku,
        quantity: variantData.quantity,
        weight: variantData.weight
      }],
      shipmentValue: {
        fractionDigits: 2,
        type: 'centPrecision',
        currencyCode: 'USD',
        centAmount: variantData.price
      }
    }],
    allowAmazonShipping: true,
    allowBlueStreak: true,
    allowCdl: true,
    allowDashlink: true,
    allowGrandHusky: true,
    allowLasership: true,
    allowOntrac: true,
    allowShipx: true,
    allowTforce: true,
    allowUds: true
  };
}
function fetchMainShippingEstimate(_x, _x2) {
  return _fetchMainShippingEstimate.apply(this, arguments);
}
function _fetchMainShippingEstimate() {
  _fetchMainShippingEstimate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(zip, variantData) {
    var payload, res, _message, message, _data$errors, data, err;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          payload = buildShippingPayload(zip, variantData);
          _context2.next = 3;
          return fetch('https://nuts.com/api/shipping-calculator', {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload)
          });
        case 3:
          res = _context2.sent;
          if (res.ok) {
            _context2.next = 18;
            break;
          }
          message = '';
          _context2.prev = 6;
          _context2.next = 9;
          return res.json();
        case 9:
          data = _context2.sent;
          message = (data === null || data === void 0 || (_data$errors = data.errors) === null || _data$errors === void 0 || (_data$errors = _data$errors[0]) === null || _data$errors === void 0 ? void 0 : _data$errors.message) || '';
          _context2.next = 15;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](6);
        case 15:
          err = new Error('Main shipping API failed');
          err.isPostalError = res.status === 400 && ((_message = message) === null || _message === void 0 ? void 0 : _message.toLowerCase().includes('postal'));
          throw err;
        case 18:
          return _context2.abrupt("return", res.json());
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 13]]);
  }));
  return _fetchMainShippingEstimate.apply(this, arguments);
}
function fetchPredictedShippingEstimate() {
  return _fetchPredictedShippingEstimate.apply(this, arguments);
}
function _fetchPredictedShippingEstimate() {
  _fetchPredictedShippingEstimate = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
    var res;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fetch('https://nuts.com/api/predicted-shipping', {
            method: 'GET',
            mode: 'cors'
          });
        case 2:
          res = _context3.sent;
          if (res.ok) {
            _context3.next = 5;
            break;
          }
          throw new Error('Predictive shipping API failed');
        case 5:
          return _context3.abrupt("return", res.json());
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchPredictedShippingEstimate.apply(this, arguments);
}
function formatArrivalLabel(iso) {
  if (!iso) return null;
  var currentDate = dayjs().startOf('day');
  var date = dayjs(iso);
  var diff = date.diff(currentDate, 'day');
  var dateText = date.format('MMMM D');
  if (diff === 0) {
    return "<strong>Today</strong>, ".concat(dateText);
  }
  if (diff === 1) {
    return "<strong>Tomorrow</strong>, ".concat(dateText);
  }
  var weekday = date.format('dddd');
  return "<strong>".concat(weekday, "</strong>, ").concat(dateText);
}
function formatCutoffTime(iso) {
  if (!iso) return '';
  var now = dayjs();
  var cutoff = dayjs(iso);
  var diff = cutoff.diff(now, 'second');
  if (diff <= 0) return '';
  var hrs = Math.floor(diff / 3600);
  var mins = Math.floor(diff % 3600 / 60);
  if (hrs > 0) return "".concat(hrs, " hrs ").concat(mins, " mins.");
  return "".concat(mins, " mins.");
}
function formatMainShippingMessage(apiData) {
  var _apiData$data, _offerSet$shippingOff, _address$city;
  var offerSet = apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 || (_apiData$data = _apiData$data.offerSets) === null || _apiData$data === void 0 ? void 0 : _apiData$data[0];
  var offer = offerSet === null || offerSet === void 0 || (_offerSet$shippingOff = offerSet.shippingOffers) === null || _offerSet$shippingOff === void 0 ? void 0 : _offerSet$shippingOff[0];
  if (!offer) return null;
  var arrivalIso = offer.latestArrivalOn;
  if (!arrivalIso) return null;
  var cutoffIso = offer.targetPickupCutoff;
  var address = offerSet === null || offerSet === void 0 ? void 0 : offerSet.address;
  var arrivalLabel = formatArrivalLabel(arrivalIso);
  if (!arrivalLabel) return null;
  var city = (address === null || address === void 0 || (_address$city = address.city) === null || _address$city === void 0 ? void 0 : _address$city.toLowerCase()) || '';
  var zip = (address === null || address === void 0 ? void 0 : address.postalCode) || '';
  return {
    html: "\n      <div class=\"flex items-center gap-1\">\n        Arrives by\n        <span class=\"bg-lime-100 px-1.5\">".concat(arrivalLabel, "</span>\n      </div>\n      <div>\n        Order within\n        <span\n          class=\"font-bold text-lime-900\"\n          data-cutoff-timer\n          data-cutoff-iso=\"").concat(cutoffIso, "\"\n        >\n          ").concat(formatCutoffTime(cutoffIso), "\n        </span>\n        <a href=\"javascript:void(0)\" class=\"delivery-location-toggle inline-flex items-center gap-0.5 cursor-pointer text-cyan-800 capitalize\" data-toggle-zip>\n          ").concat(city, " - ").concat(zip, "\n          <svg class=\"delivery-arrow transition-transform duration-150 [&.is-open]:rotate-180\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\"\n            xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M4 6L8 10L12 6\" stroke=\"#08596D\" stroke-width=\"1.3\" stroke-linecap=\"square\"/>\n          </svg>\n        </a>\n      </div>\n    ")
  };
}
function formatPredictedShippingMessage(apiData) {
  var data = apiData === null || apiData === void 0 ? void 0 : apiData.data;
  if (!data) return null;
  var expiresInSeconds = data.expiresInSeconds,
    friendly = data.friendly,
    date = data.date;

  // If countdown available
  if (expiresInSeconds && expiresInSeconds > 0) {
    return {
      type: 'countdown',
      expiresInSeconds: expiresInSeconds,
      friendly: friendly || null,
      date: date || null
    };
  }

  // Fallback date
  if (date) {
    var shipDate = dayjs_min_default()(date);
    var dateLabel = shipDate.format('dddd, MMM D');
    return {
      type: 'date',
      text: "Order now and we'll ship",
      dateLabel: dateLabel
    };
  }
  return null;
}
;// ./src/js/utils/icons.js
var getAtcSuccessIcon = function getAtcSuccessIcon() {
  return "\n  <svg class=\"w-6 h-6 lg:w-8 lg:h-8\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g clip-path=\"url(#clip0_6781_82116)\">\n      <path d=\"M16.0003 2.66675C8.64033 2.66675 2.66699 8.64008 2.66699 16.0001C2.66699 23.3601 8.64033 29.3334 16.0003 29.3334C23.3603 29.3334 29.3337 23.3601 29.3337 16.0001C29.3337 8.64008 23.3603 2.66675 16.0003 2.66675ZM13.3337 22.6667L6.66699 16.0001L8.54699 14.1201L13.3337 18.8934L23.4537 8.77342L25.3337 10.6667L13.3337 22.6667Z\" fill=\"#4A8500\"/>\n    </g>\n    <defs>\n      <clipPath id=\"clip0_6781_82116\">\n        <rect width=\"32\" height=\"32\" fill=\"white\"/>\n      </clipPath>\n    </defs>\n  </svg>\n";
};
;// ./src/js/bundles/snippets/atc-drawer.ts









var ATC_SECTION_ID = 'add-to-cart-drawer-content';
var getAtcSectionId = function getAtcSectionId() {
  return ATC_SECTION_ID;
};
var renderAtcDrawer = function renderAtcDrawer(renderedSections, addedKey, contextEl) {
  var _window$GlobalDrawer;
  var variantId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (!((_window$GlobalDrawer = window.GlobalDrawer) !== null && _window$GlobalDrawer !== void 0 && _window$GlobalDrawer.loadDrawer) || !renderedSections || !addedKey) return;
  var drawerHtml = renderedSections[getAtcSectionId()];
  if (!drawerHtml) return;
  var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
  var container = doc.querySelector('[data-cart-items]');
  if (!container) return;
  var addedItem = container.querySelector("[data-key=\"".concat(addedKey, "\"]"));
  if (!addedItem) return;
  container.innerHTML = '';
  container.appendChild(addedItem);
  var drawerContent = {
    title: "\n      <span class=\"flex gap-2 items-center\">\n        <span class=\"flex-shrink-0\">".concat(getAtcSuccessIcon(), "</span>\n        Added to cart\n      </span>\n    "),
    content: doc.body.innerHTML
  };
  window.GlobalDrawer.loadDrawer(contextEl, drawerContent, 'wide');
  initAtcShippingMeter();
  window.GlobalDrawer.currentAtcItemKey = addedKey;
  if (variantId) window.GlobalDrawer.currentAtcVariantId = variantId;
  var productId = addedItem.getAttribute('data-product-id');
  renderAtcRecommendations(productId);
  renderAtcShippingMessage();
};
var refreshAtcDrawerContent = function refreshAtcDrawerContent(renderedSections, addedKey) {
  var _addedItem$getAttribu, _addedItem$getAttribu2;
  var addedVariantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var _window = window,
    GlobalDrawer = _window.GlobalDrawer;
  if (!GlobalDrawer || !renderedSections || !addedKey) return;
  var drawerContent = GlobalDrawer.content;
  if (!drawerContent) return;
  var drawerHtml = renderedSections[getAtcSectionId()];
  if (!drawerHtml) return;
  var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');

  // filter only added item
  var container = doc.querySelector('[data-cart-items]');
  if (!container) return;
  var addedItem = container.querySelector("[data-key=\"".concat(addedKey, "\"]"));

  // Fallback: match by variant id
  if (!addedItem && addedVariantId) {
    addedItem = container.querySelector("[data-variant-id=\"".concat(addedVariantId, "\"]"));
  }
  if (!addedItem) return;

  // sync latest key & variant id
  var freshKey = (_addedItem$getAttribu = addedItem.getAttribute('data-key')) !== null && _addedItem$getAttribu !== void 0 ? _addedItem$getAttribu : undefined;
  var freshVariantId = (_addedItem$getAttribu2 = addedItem.getAttribute('data-variant-id')) !== null && _addedItem$getAttribu2 !== void 0 ? _addedItem$getAttribu2 : undefined;
  GlobalDrawer.currentAtcItemKey = freshKey;
  GlobalDrawer.currentAtcVariantId = freshVariantId;
  container.innerHTML = '';
  container.appendChild(addedItem);

  // update only refreshable content
  var newContent = doc.querySelector('[data-content-refresh]');
  var currentContent = drawerContent.querySelector('[data-content-refresh]');
  if (!newContent || !currentContent) return;
  currentContent.innerHTML = newContent.innerHTML;
  initAtcShippingMeter();
};
var initAtcDrawerQtyHandlers = function initAtcDrawerQtyHandlers(drawerContent) {
  if (!drawerContent) return;

  // prevent duplicate binding
  if (drawerContent.dataset.atcQtyBound) return;
  drawerContent.dataset.atcQtyBound = 'true';
  drawerContent.addEventListener('click', handleQtyClick);
  drawerContent.addEventListener('change', handleQtyChange);
  drawerContent.addEventListener('keydown', handleQtyKeydown);
};
var handleQtyClick = function handleQtyClick(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('[data-atc-drawer]')) return;
  var btn = event.target.closest('[data-qty-btn]');
  if (!btn) return;
  var container = btn.closest('[data-qty-container]');
  var input = container === null || container === void 0 ? void 0 : container.querySelector('[data-cart-qty]');
  if (!input) return;
  var isDecrease = btn.dataset.qtyBtn === 'decrease';
  if (isDecrease) {
    if (Number(input.value) <= 1) return;
    input.stepDown();
  } else {
    input.stepUp();
  }
  input.dispatchEvent(new Event('change', {
    bubbles: true
  }));
};
var handleQtyChange = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
    var _container$querySelec;
    var input, quantity, itemKey, itemVariantId, container, btns, elements, sectionId, cartSectionId, isCartPage, sections, response, data, cartSectionMarkup, _window$refreshCartSe, _window2, fsCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (event.target instanceof Element) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          if (event.target.closest('[data-atc-drawer]')) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          input = event.target.closest('[data-cart-qty]');
          if (input) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return");
        case 7:
          quantity = Math.max(1, Number(input.value) || 1);
          itemKey = input.dataset.itemKey;
          itemVariantId = input.dataset.itemVariantId;
          if (itemKey) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return");
        case 12:
          container = input.closest('[data-qty-container]');
          btns = Array.from((_container$querySelec = container === null || container === void 0 ? void 0 : container.querySelectorAll('[data-qty-btn]')) !== null && _container$querySelec !== void 0 ? _container$querySelec : []);
          elements = [input].concat(btns);
          elements.forEach(function (el) {
            el.disabled = true;
            el.classList.add('opacity-50', 'pointer-events-none');
          });
          document.body.style.cursor = 'wait';
          _context.prev = 17;
          sectionId = getAtcSectionId();
          cartSectionId = getCartSectionId();
          isCartPage = window.location.pathname.includes('/cart');
          sections = isCartPage ? [cartSectionId, sectionId] : [sectionId];
          _context.next = 24;
          return cartApi.updateQty(itemKey, quantity, sections);
        case 24:
          response = _context.sent;
          _context.next = 27;
          return response.json();
        case 27:
          data = _context.sent;
          refreshAtcDrawerContent(data === null || data === void 0 ? void 0 : data.sections, itemKey, itemVariantId);
          if (!data) {
            _context.next = 40;
            break;
          }
          if (!isCartPage) {
            _context.next = 37;
            break;
          }
          cartSectionMarkup = data.sections[cartSectionId];
          if (!cartSectionMarkup) {
            _context.next = 35;
            break;
          }
          _context.next = 35;
          return (_window$refreshCartSe = (_window2 = window).refreshCartSection) === null || _window$refreshCartSe === void 0 ? void 0 : _window$refreshCartSe.call(_window2, cartSectionMarkup);
        case 35:
          _context.next = 40;
          break;
        case 37:
          updateCartUI(data === null || data === void 0 ? void 0 : data.item_count);
          fsCode = getFSDiscountInfo(data);
          if (fsCode) {
            updateShippingMeter(data.total_price, fsCode.threshold);
          }
        case 40:
          _context.next = 45;
          break;
        case 42:
          _context.prev = 42;
          _context.t0 = _context["catch"](17);
          console.error('ATC qty update failed:', _context.t0);
        case 45:
          _context.prev = 45;
          elements.forEach(function (el) {
            el.disabled = false;
            el.classList.remove('opacity-50', 'pointer-events-none');
          });
          document.body.style.cursor = '';
          return _context.finish(45);
        case 49:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[17, 42, 45, 49]]);
  }));
  return function handleQtyChange(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var handleQtyKeydown = function handleQtyKeydown(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('[data-atc-drawer]')) return;
  if (!event.target.closest('[data-cart-qty]')) return;
  if (['e', 'E', '+', '-'].includes(event.key)) {
    event.preventDefault();
  }
};
var renderAtcRecommendations = /*#__PURE__*/function () {
  var _ref2 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(productId) {
    var _window$GlobalDrawer2;
    var drawerContent, currentContainer, sectionId, url, response, html, doc, newContainer;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          drawerContent = (_window$GlobalDrawer2 = window.GlobalDrawer) === null || _window$GlobalDrawer2 === void 0 ? void 0 : _window$GlobalDrawer2.content;
          if (!(!drawerContent || !productId)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          currentContainer = drawerContent.querySelector('[data-atc-recommendations]');
          if (currentContainer) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          sectionId = getAtcSectionId();
          url = "".concat(window.Shopify.routes.root, "recommendations/products?section_id=").concat(sectionId, "&intent=related&product_id=").concat(productId);
          _context2.prev = 8;
          _context2.next = 11;
          return fetch(url);
        case 11:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 14;
            break;
          }
          throw new Error('Failed to fetch recommendations');
        case 14:
          _context2.next = 16;
          return response.text();
        case 16:
          html = _context2.sent;
          doc = new DOMParser().parseFromString(html, 'text/html');
          newContainer = doc.querySelector('[data-atc-recommendations]');
          if (newContainer) {
            _context2.next = 21;
            break;
          }
          return _context2.abrupt("return");
        case 21:
          if (newContainer.innerHTML.trim()) {
            currentContainer.innerHTML = newContainer.innerHTML;
            currentContainer.classList.remove('hidden');
          } else {
            currentContainer.innerHTML = '';
            currentContainer.classList.add('hidden');
          }
          _context2.next = 27;
          break;
        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](8);
          console.error('ATC recommendations failed:', _context2.t0);
        case 27:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[8, 24]]);
  }));
  return function renderAtcRecommendations(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var initAtcRecoHandlers = function initAtcRecoHandlers(drawerContent) {
  if (!drawerContent) return;
  if (drawerContent.dataset.atcRecoBound) return;
  drawerContent.dataset.atcRecoBound = 'true';
  drawerContent.addEventListener('click', handleAtcRecoClick);
};
var handleAtcRecoClick = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
    var btn, variantId, _window$GlobalDrawer3, _window$GlobalDrawer4, sectionId, cartSectionId, isCartPage, sections, data, itemKey, itemVariantId, _data$sections, cartSectionMarkup, _window$refreshCartSe2, _window3, message;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (event.target instanceof Element) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          btn = event.target.closest('[data-atc-reco-add]');
          if (!(!btn || btn.classList.contains('processing'))) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return");
        case 5:
          variantId = btn.dataset.variantId;
          if (variantId) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return");
        case 8:
          // UI state
          btn.classList.add('processing');
          _context3.prev = 9;
          sectionId = getAtcSectionId();
          cartSectionId = getCartSectionId();
          isCartPage = window.location.pathname.includes('/cart');
          sections = isCartPage ? [cartSectionId, sectionId].join(',') : sectionId;
          publishAtcContextFromElement(btn, variantId);
          _context3.next = 17;
          return addItemToCart({
            id: Number(variantId),
            quantity: 1,
            properties: {}
          }, {
            sections: sections,
            sectionsUrl: window.location.pathname
          });
        case 17:
          data = _context3.sent;
          itemKey = (_window$GlobalDrawer3 = window.GlobalDrawer) === null || _window$GlobalDrawer3 === void 0 ? void 0 : _window$GlobalDrawer3.currentAtcItemKey;
          itemVariantId = (_window$GlobalDrawer4 = window.GlobalDrawer) === null || _window$GlobalDrawer4 === void 0 ? void 0 : _window$GlobalDrawer4.currentAtcVariantId; // refresh drawer but keep same item
          refreshAtcDrawerContent(data.sections, itemKey, itemVariantId);
          if (!isCartPage) {
            _context3.next = 28;
            break;
          }
          cartSectionMarkup = (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections[cartSectionId];
          if (!cartSectionMarkup) {
            _context3.next = 26;
            break;
          }
          _context3.next = 26;
          return (_window$refreshCartSe2 = (_window3 = window).refreshCartSection) === null || _window$refreshCartSe2 === void 0 ? void 0 : _window$refreshCartSe2.call(_window3, cartSectionMarkup);
        case 26:
          _context3.next = 30;
          break;
        case 28:
          _context3.next = 30;
          return handleCartMutationSuccess();
        case 30:
          btn.classList.add('atc-success');
          btn.disabled = true;
          _context3.next = 39;
          break;
        case 34:
          _context3.prev = 34;
          _context3.t0 = _context3["catch"](9);
          message = _context3.t0 instanceof Error && _context3.t0.message;
          alert(message || 'Something went wrong');
          console.error('ATC reco add failed:', _context3.t0);
        case 39:
          _context3.prev = 39;
          btn.classList.remove('processing');
          return _context3.finish(39);
        case 42:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[9, 34, 39, 42]]);
  }));
  return function handleAtcRecoClick(_x3) {
    return _ref3.apply(this, arguments);
  };
}()));
var initAtcShippingMeter = function initAtcShippingMeter() {
  var _window$GlobalDrawer5;
  var drawerContent = (_window$GlobalDrawer5 = window.GlobalDrawer) === null || _window$GlobalDrawer5 === void 0 ? void 0 : _window$GlobalDrawer5.content;
  if (!drawerContent) return;
  var meter = drawerContent.querySelector('[data-shipping-meter]');
  if (!meter) return;
  initShippingInfoPopover(meter);
};
var renderAtcShippingMessage = /*#__PURE__*/function () {
  var _ref4 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
    var _window$GlobalDrawer6;
    var dynamicEl, predictiveData, formatted, messageHTML, totalMinutes, hours, minutes, timeLabel, shipLabel;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dynamicEl = (_window$GlobalDrawer6 = window.GlobalDrawer) === null || _window$GlobalDrawer6 === void 0 ? void 0 : _window$GlobalDrawer6.dynamicContent;
          if (dynamicEl) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return fetchPredictedShippingEstimate();
        case 6:
          predictiveData = _context4.sent;
          formatted = formatPredictedShippingMessage(predictiveData);
          if (formatted) {
            _context4.next = 10;
            break;
          }
          return _context4.abrupt("return");
        case 10:
          messageHTML = ''; // Countdown version
          if (formatted.type === 'countdown' && formatted.expiresInSeconds) {
            totalMinutes = Math.floor(formatted.expiresInSeconds / 60);
            hours = Math.floor(totalMinutes / 60);
            minutes = totalMinutes === 0 && formatted.expiresInSeconds > 0 ? 1 : totalMinutes % 60;
            timeLabel = [hours ? "".concat(hours, " hr").concat(hours > 1 ? 's' : '') : '', minutes ? "".concat(minutes, " min").concat(minutes > 1 ? 's' : '') : ''].filter(Boolean).join(' ');
            shipLabel = formatted.friendly || 'today';
            messageHTML = "\n        If you order within the next <strong>".concat(timeLabel, "</strong> we'll ship <strong>").concat(shipLabel, "!</strong>\n      ");
          }
          // Date version
          else if (formatted.type === 'date' && formatted.dateLabel) {
            messageHTML = "\n        ".concat(formatted.text, " <strong>").concat(formatted.dateLabel, "</strong>.\n      ");
          }
          if (messageHTML) {
            _context4.next = 14;
            break;
          }
          return _context4.abrupt("return");
        case 14:
          dynamicEl.innerHTML = "\n      <div\n        data-atc-shipping-message\n        class=\"px-4 py-1 text-sm text-center lg:text-base bg-nuts-amber-200\"\n      >\n        ".concat(messageHTML, "\n      </div>\n    ");
          dynamicEl.classList.remove('hidden');
          _context4.next = 21;
          break;
        case 18:
          _context4.prev = 18;
          _context4.t0 = _context4["catch"](3);
          console.error('ATC shipping message failed:', _context4.t0);
        case 21:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 18]]);
  }));
  return function renderAtcShippingMessage() {
    return _ref4.apply(this, arguments);
  };
}();
;// ./src/js/utils/cart.ts
/** Free-shipping tier as authored in the section settings. */

var cart_getCartSectionId = function getCartSectionId() {
  var _document$querySelect;
  return ((_document$querySelect = document.querySelector('[data-cart-page-section]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('data-cart-page-section')) || 'cart-page';
};
var compileCopy = function compileCopy(copy) {
  var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return copy.replace(/\[(amount-left)\]/gi, function (_, litral) {
    var _vars$litral$toLowerC;
    return (_vars$litral$toLowerC = vars === null || vars === void 0 ? void 0 : vars[litral === null || litral === void 0 ? void 0 : litral.toLowerCase()]) !== null && _vars$litral$toLowerC !== void 0 ? _vars$litral$toLowerC : litral;
  });
};
var getTierProgress = function getTierProgress(_ref) {
  var tiers = _ref.tiers,
    spentAmount = _ref.spentAmount,
    index = _ref.index;
  var props = {
    progress: 0,
    isQualified: false,
    isCurrent: false
  };
  var threshold = tiers[index]['threshold-amount'];
  var baseDiff = spentAmount / threshold * 100;
  var match = baseDiff <= 100;
  if (match) {
    var diff;
    if (!index) diff = baseDiff;else {
      var previousThreshold = tiers[index - 1]['threshold-amount'];
      var currentBase = spentAmount - previousThreshold;
      var compareAgainst = threshold - previousThreshold;
      diff = currentBase / compareAgainst * 100;
    }
    props.progress = Math.max(0, diff);
    if (props.progress === 100) props.isQualified = true;
  } else {
    props.progress = 100;
    props.isQualified = true;
  }
  if (!props.isQualified) {
    var _tiers;
    if (!index) props.isCurrent = true;else if (tiers !== null && tiers !== void 0 && (_tiers = tiers[index - 1]) !== null && _tiers !== void 0 && _tiers.isQualified) {
      props.isCurrent = true;
    }
  }
  return props;
};
var cart_getFSDiscountInfo = function getFSDiscountInfo() {
  var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var discountCodes = cart.discount_codes || [];
  if (!discountCodes.length) return null;
  var fsCode = discountCodes.find(function (_ref2) {
    var code = _ref2.code,
      applicable = _ref2.applicable;
    return applicable === true && typeof code === 'string' && /FS\d+/.test(code);
  });
  if (!fsCode) return null;
  var match = fsCode.code.match(/FS(\d+)/);
  if (!match) return null;
  var threshold = parseInt(match[1], 10);
  return {
    code: fsCode.code,
    threshold: threshold
  };
};
;// ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

;// ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

;// ./node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

;// ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

;// ./src/js/utils/cart-api.ts









function cart_api_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function cart_api_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cart_api_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cart_api_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}


/** Carries the failing cart action so handlers can tell the flows apart. */
var CartApiError = /*#__PURE__*/function (_Error) {
  function CartApiError(message, action) {
    var _this2;
    _classCallCheck(this, CartApiError);
    _this2 = _callSuper(this, CartApiError, [message]);
    _this2.action = action;
    return _this2;
  }
  _inherits(CartApiError, _Error);
  return _createClass(CartApiError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var apiCall = /*#__PURE__*/function () {
  var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(endpoint) {
    var method,
      payload,
      msgConfig,
      response,
      errorData,
      _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          method = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'POST';
          payload = _args.length > 2 ? _args[2] : undefined;
          msgConfig = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
          _context.prev = 3;
          _context.next = 6;
          return fetch(endpoint, {
            method: method,
            headers: {
              'Content-Type': 'application/json'
            },
            body: payload ? JSON.stringify(payload) : null
          });
        case 6:
          response = _context.sent;
          if (response.ok) {
            _context.next = 12;
            break;
          }
          _context.next = 10;
          return response.json();
        case 10:
          errorData = _context.sent;
          throw new CartApiError(errorData.message || msgConfig.error || 'Something went wrong', msgConfig.action);
        case 12:
          return _context.abrupt("return", response);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](3);
          alert("Sorry, we couldn't complete that.");
          console.error('Cart API Error:', {
            message: _context.t0 instanceof Error ? _context.t0.message : undefined,
            action: _context.t0 instanceof CartApiError ? _context.t0.action : undefined,
            error: _context.t0
          });
          throw _context.t0;
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 15]]);
  }));
  return function apiCall(_x) {
    return _ref.apply(this, arguments);
  };
}();
var cart_api_cartApi = {
  updateQty: function updateQty(itemKey, quantity) {
    var sections = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var sectionsUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.location.pathname;
    var payload = cart_api_objectSpread(cart_api_objectSpread({
      id: String(itemKey),
      quantity: quantity
    }, sections && {
      sections: sections
    }), sectionsUrl && sections && {
      sections_url: sectionsUrl
    });
    var msgConfig = {
      action: 'updateQty',
      error: 'An error occurred while updating the cart.'
    };
    return apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },
  addToCart: function addToCart(variantId) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var properties = arguments.length > 2 ? arguments[2] : undefined;
    var sections = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var sectionsUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.pathname;
    var payload = cart_api_objectSpread(cart_api_objectSpread(cart_api_objectSpread({
      id: String(variantId),
      quantity: quantity
    }, properties && Object.keys(properties).length > 0 ? {
      properties: properties
    } : {}), sections && {
      sections: sections
    }), sectionsUrl && sections && {
      sections_url: sectionsUrl
    });
    return apiCall('/cart/add.js', 'POST', payload);
  },
  addFreeGift: function addFreeGift(freeGiftVariantId) {
    var payload = {
      items: [{
        id: String(freeGiftVariantId),
        quantity: 1,
        properties: {
          _is_free_gift: 'true'
        }
      }]
    };
    var msgConfig = {
      action: 'addFreeGift',
      error: 'An error occurred while adding the free gift.'
    };
    return apiCall('/cart/add.js', 'POST', payload, msgConfig);
  },
  removeFreeGift: function removeFreeGift(lineItems) {
    var _lineItems$find;
    var freeGiftItemKey = (_lineItems$find = lineItems.find(function (item) {
      return item.properties && item.properties._is_free_gift === 'true';
    })) === null || _lineItems$find === void 0 ? void 0 : _lineItems$find.key;
    if (!freeGiftItemKey) return;
    var payload = {
      id: String(freeGiftItemKey),
      quantity: 0
    };
    var msgConfig = {
      action: 'removeFreeGift',
      error: 'An error occurred while removing the free gift.'
    };
    apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },
  updateSellingPlan: function updateSellingPlan(sellingPlanId, itemKey, quantity) {
    var sections = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var sectionsUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.pathname;
    var payload = cart_api_objectSpread(cart_api_objectSpread({
      id: String(itemKey),
      quantity: quantity,
      selling_plan: sellingPlanId
    }, sections && {
      sections: sections
    }), sectionsUrl && sections && {
      sections_url: sectionsUrl
    });
    var msgConfig = {
      action: 'updateSellingPlan',
      error: 'An error occurred while updating the selling plan.'
    };
    return apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },
  updateLineItemProperties: function updateLineItemProperties(lineIndex, quantity, properties) {
    var setLoading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return undefined;
    };
    setLoading({
      status: true,
      lineIndex: lineIndex,
      action: 'updateProperties'
    });
    // Use 'line' (1-based index) instead of 'id' for property updates
    var payload = {
      line: lineIndex,
      quantity: quantity,
      properties: properties
    };
    var msgConfig = {
      action: 'updateLineItemProperties',
      error: 'An error occurred while updating the item.'
    };
    return apiCall('/cart/change.js', 'POST', payload, msgConfig)["finally"](function () {
      setLoading(null);
    });
  }
};
var fetchCart = /*#__PURE__*/function () {
  var _ref2 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
    var response;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          });
        case 2:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 5;
            break;
          }
          throw new Error('Failed to fetch cart');
        case 5:
          return _context2.abrupt("return", response.json());
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchCart() {
    return _ref2.apply(this, arguments);
  };
}();
var cart_api_updateCartUI = function updateCartUI(cartCount) {
  var countEl = document.getElementById('cart-item-count');
  if (countEl) {
    countEl.textContent = String(cartCount);
  }
};

// Webpack inlines this module into every entry bundle, so a module-level
// variable would give each bundle its own dedupe state. Keep it page-global.
var SIGNATURE_KEY = '__nutsLastSyncedCartSignature';
var getLastSyncedSignature = function getLastSyncedSignature() {
  var _window$SIGNATURE_KEY;
  return (_window$SIGNATURE_KEY = window[SIGNATURE_KEY]) !== null && _window$SIGNATURE_KEY !== void 0 ? _window$SIGNATURE_KEY : null;
};
var setLastSyncedSignature = function setLastSyncedSignature(signature) {
  window[SIGNATURE_KEY] = signature;
};
var cartSignature = function cartSignature(cart) {
  return [cart.item_count, cart.total_price].concat(_toConsumableArray((cart.items || []).map(function (item) {
    return "".concat(item.key, ":").concat(item.quantity);
  }))).join('|');
};
var dispatchCartUpdated = function dispatchCartUpdated(cart) {
  if (!cart) {
    console.error('[cart-events] dispatchCartUpdated called without cart');
    return;
  }

  // Flows that dispatch directly (e.g. the cart page) count as a sync too, so
  // the fetch-interceptor's follow-up refresh doesn't fire cart:updated again.
  setLastSyncedSignature(cartSignature(cart));
  document.dispatchEvent(new CustomEvent('cart:updated', {
    detail: {
      cart: cart
    }
  }));
};
var syncCartUIFromCart = function syncCartUIFromCart(cart) {
  if (!cart) return;
  if (cartSignature(cart) === getLastSyncedSignature()) return;
  var fsCode = cart_getFSDiscountInfo(cart);
  if (fsCode) {
    shipping_meter_updateShippingMeter(cart.total_price, fsCode.threshold);
  }
  dispatchCartUpdated(cart);
  cart_api_updateCartUI(cart.item_count);
};
var cart_api_handleCartMutationSuccess = /*#__PURE__*/function () {
  var _ref3 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
    var cart;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetchCart();
        case 3:
          cart = _context3.sent;
          if (cart) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
          syncCartUIFromCart(cart);
          return _context3.abrupt("return", cart);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          console.error('Cart sync failed:', _context3.t0);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 10]]);
  }));
  return function handleCartMutationSuccess() {
    return _ref3.apply(this, arguments);
  };
}();
;// ./src/js/utils/variant.js



function variant_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function variant_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? variant_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : variant_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var postAddToCart = /*#__PURE__*/function () {
  var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(variantId, frequencyId) {
    var quantity,
      contextEl,
      properties,
      isProcessing,
      payload,
      atcSection,
      isCartPage,
      cartSection,
      sections,
      response,
      errorData,
      responseData,
      _ref2,
      renderedSections,
      addedKey,
      _window,
      sectionHtml,
      _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          quantity = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1;
          contextEl = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
          properties = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
          if (variantId) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          isProcessing = contextEl && contextEl.classList.contains('processing');
          if (!isProcessing) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          payload = {
            id: parseInt(variantId),
            quantity: quantity
          };
          if (frequencyId) payload.selling_plan = parseInt(frequencyId);
          if (properties && Object.keys(properties).length) {
            payload.properties = properties;
          }
          if (contextEl) {
            contextEl.classList.add('processing');
          }
          atcSection = getAtcSectionId();
          isCartPage = window.location.pathname.includes('/cart');
          cartSection = cart_getCartSectionId();
          sections = isCartPage ? [cartSection, atcSection] : [atcSection];
          _context.prev = 16;
          _context.next = 19;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(variant_objectSpread(variant_objectSpread({}, payload), {}, {
              sections: sections,
              sections_url: window.location.pathname
            }))
          });
        case 19:
          response = _context.sent;
          if (response.ok) {
            _context.next = 25;
            break;
          }
          _context.next = 23;
          return response.json();
        case 23:
          errorData = _context.sent;
          throw new Error(errorData.message || "Sorry, couldn't add product to cart");
        case 25:
          _context.next = 27;
          return response.json();
        case 27:
          responseData = _context.sent;
          _ref2 = responseData || {}, renderedSections = _ref2.sections, addedKey = _ref2.key; // render Add to Cart drawer
          renderAtcDrawer(renderedSections, addedKey, contextEl, variantId);

          // Cart Page & Cart item count handling
          if (!isCartPage) {
            _context.next = 36;
            break;
          }
          sectionHtml = renderedSections === null || renderedSections === void 0 ? void 0 : renderedSections[cartSection];
          _context.next = 34;
          return (_window = window) === null || _window === void 0 ? void 0 : _window.refreshCartSection(sectionHtml);
        case 34:
          _context.next = 38;
          break;
        case 36:
          _context.next = 38;
          return cart_api_handleCartMutationSuccess();
        case 38:
          return _context.abrupt("return", responseData);
        case 41:
          _context.prev = 41;
          _context.t0 = _context["catch"](16);
          alert(_context.t0.message || "Sorry, we couldn't complete that.");
          console.error('Error adding to cart:', _context.t0);
        case 45:
          _context.prev = 45;
          if (contextEl) {
            contextEl.classList.remove('processing');
          }
          return _context.finish(45);
        case 48:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[16, 41, 45, 48]]);
  }));
  return function postAddToCart(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
;// ./src/js/bundles/snippets/product-card.js





/**
 * Equalizes the height of product card titles within each row
 * @param {HTMLElement|string|null} container - Container element, selector, or null to search globally
 */
function equaliseTitleHeights() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var searchContainer = null;
  if (container) {
    // If container is a string selector, query for it
    if (typeof container === 'string') {
      searchContainer = document.querySelector(container);
    } else if (container instanceof HTMLElement) {
      // If container is an element, use it directly
      searchContainer = container;
    }
  }

  // If no container provided or found, search globally
  if (!searchContainer) {
    searchContainer = document;
  }

  // Find all product cards within the search container
  // Works with grids, swipers, and any other layout
  var cards = Array.from(searchContainer.querySelectorAll('.js-product-card'));
  if (!cards.length) return;

  // Group cards by their parent container (for handling multiple sections/swipers separately)
  var containerGroups = new Map();
  cards.forEach(function (card) {
    // Find the closest container that groups cards together
    var parentContainer = card.closest('.product-grid__container') || card.closest('.product-grid__wrapper') || card.closest('.js-product-grid') || card.closest('.js-products-grid') || card.closest('section') || card.parentElement;
    var containerId = parentContainer ? parentContainer.getAttribute('id') || parentContainer.className || "".concat(parentContainer.tagName, "-").concat(containerGroups.size) : 'default';
    if (!containerGroups.has(containerId)) {
      containerGroups.set(containerId, []);
    }
    containerGroups.get(containerId).push(card);
  });

  // Process each container group separately
  containerGroups.forEach(function (groupCards) {
    processCardsInGroup(groupCards);
  });
}

/**
 * Processes a group of cards to equalize title heights within rows
 */
function processCardsInGroup(cards) {
  // Group titles by row (using card offsetTop)
  var rows = {};
  cards.forEach(function (card) {
    var title = card.querySelector('.js-product-card-title');
    if (!title) return;

    // Reset height before measuring
    title.style.minHeight = '';
    var top = Math.round(card.offsetTop); // row id
    if (!rows[top]) {
      rows[top] = {
        titles: [],
        maxHeight: 0
      };
    }
    var h = title.offsetHeight;
    rows[top].titles.push(title);
    if (h > rows[top].maxHeight) {
      rows[top].maxHeight = h;
    }
  });

  // Apply per-row max height
  Object.values(rows).forEach(function (row) {
    row.titles.forEach(function (title) {
      title.style.minHeight = "".concat(row.maxHeight, "px");
    });
  });
}
function formatAverageRating(rawValue) {
  var numeric = Number(rawValue);
  if (!Number.isFinite(numeric)) return null;
  var rounded = Math.round(numeric * 100) / 100;
  return rounded.toFixed(2).replace(/\.?0+$/, '');
}
function formatCardRatings(container) {
  var root = container instanceof HTMLElement ? container : typeof container === 'string' ? document.querySelector(container) : document;
  if (!root) return;
  root.querySelectorAll('.product-card-star-rating .jdgm-prev-badge').forEach(function (badge) {
    var _badge$dataset;
    var raw = badge.getAttribute('data-average-rating') || ((_badge$dataset = badge.dataset) === null || _badge$dataset === void 0 ? void 0 : _badge$dataset.averageRating) || '';
    var display = formatAverageRating(raw);
    if (!display) return;
    badge.setAttribute('data-avg-display', display);
  });
}
var productCard = {
  collectionContainer: null,
  initializeEvents: function initializeEvents(container) {
    this.initializeElements(container);
    this.addEventListenersToAllCards();
    formatCardRatings(this.collectionContainer || document);
  },
  initializeElements: function initializeElements(container) {
    this.collectionContainer = document.querySelector(container);
    if (!this.collectionContainer) {
      console.error('Collection container not found');
    }
  },
  addEventListenersToAllCards: function addEventListenersToAllCards() {
    var _this = this;
    if (!this.collectionContainer) return;
    var productCards = this.collectionContainer.querySelectorAll('.js-product-card');
    productCards.forEach(function (card) {
      var isEventInitialized = card.dataset.eventInitialized;
      if (isEventInitialized) return;
      card.dataset.eventInitialized = 'true';
      var addToBagButton = card.querySelector('.js-add-to-bag-cta');
      if (addToBagButton) {
        addToBagButton.addEventListener('click', /*#__PURE__*/asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.handleQuickAdd(card);
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })));
      }
    });
  },
  handleQuickAdd: function handleQuickAdd(card) {
    return asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
      var cardCta, _ref2, variantsCount, firstVariantId, firstVariantAvailable, hasSingleVariant, ctaText, ctaLoader;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cardCta = card.querySelector('.js-add-to-bag-cta');
            if (cardCta) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _ref2 = cardCta.dataset || {}, variantsCount = _ref2.variantsCount, firstVariantId = _ref2.firstVariantId, firstVariantAvailable = _ref2.firstVariantAvailable;
            hasSingleVariant = variantsCount && parseInt(variantsCount, 10) === 1;
            ctaText = cardCta.querySelector('.js-add-to-bag-text');
            ctaLoader = cardCta.querySelector('.js-quick-buy-cta-loader');
            if (!(hasSingleVariant && firstVariantAvailable === 'true' && firstVariantId)) {
              _context2.next = 25;
              break;
            }
            cardCta.classList.add('processing');
            if (ctaText) ctaText.classList.add('processing');
            if (ctaLoader) ctaLoader.classList.add('processing');
            _context2.prev = 11;
            publishAtcContext_publishAtcContextFromElement(cardCta, firstVariantId);
            _context2.next = 15;
            return postAddToCart(firstVariantId);
          case 15:
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](11);
            console.error('Error adding product to cart', _context2.t0);
          case 20:
            _context2.prev = 20;
            cardCta.classList.remove('processing');
            if (ctaText) ctaText.classList.remove('processing');
            if (ctaLoader) ctaLoader.classList.remove('processing');
            return _context2.finish(20);
          case 25:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[11, 17, 20, 25]]);
    }))();
  }
};
/* harmony default export */ const product_card = (productCard);
;// ./src/js/bundles/templates/collection.js


function isAlgoliaReactPlp() {
  var el = document.querySelector('.js-collection-container');
  return el && el.dataset.algoliaPlp === 'true';
}
function resolvePlpContainer(event) {
  var selector = event && event.detail && event.detail.container ? event.detail.container : null;
  if (selector && document.querySelector(selector)) return selector;
  if (document.querySelector('.js-collection-container')) {
    return '.js-collection-container';
  }
  return null;
}
function reinitPlpFeatures(event) {
  var selector = resolvePlpContainer(event);
  if (!selector) return;
  product_card.initializeEvents(selector);
  equaliseTitleHeights(selector);
}
document.addEventListener('DOMContentLoaded', function () {
  // If this is Algolia React PLP, skip Shopify AJAX section rendering.
  if (isAlgoliaReactPlp()) {
    window.addEventListener('plp:rendered', reinitPlpFeatures);
    return;
  }

  // Shopify (non-Algolia) PLP still uses the drawer here.
  filters_drawer();
});
})();

/******/ })()
;